import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// Backend contract (api/admin/klaviyo.js): GET /account is readable by ANY domain admin -
// only the mutating routes are super-admin gated. SettingsTabEmails relies on this to hide
// the Releva sending settings for every user of a Klaviyo-connected domain; the response
// passes through toJSON, which strips refreshToken/apiKey, so no secrets reach non-super-admins.
export const getKlaviyoAccount = createAsyncThunk('klaviyo/getAccount', async ({ accountId, domainId }) => {
  const response = await fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/klaviyo/account`);
  return await response.json();
});

export const klaviyoSlice = createSlice({
  name: 'klaviyo',
  initialState: {
    account: null,
    // Whether the backend has the Releva-side Klaviyo OAuth app credentials; until it
    // does, the UI only offers the private-API-key connect.
    oauthConfigured: false,
    loading: null,
    error: null,
  },
  reducers: {
    setKlaviyoAccount: (state, action) => {
      state.account = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getKlaviyoAccount.pending, (state) => {
        // Reset on every (re)fetch: safety alerts and send gating read `account`, and
        // a stale account from a previously viewed domain must never suppress another
        // domain's warnings. Consumers gate on `loading === false` to avoid flicker.
        state.account = null;
        state.loading = true;
        state.error = false;
      })
      .addCase(getKlaviyoAccount.fulfilled, (state, action) => {
        const account = action.payload.klaviyoAccount;
        state.account = account;
        state.oauthConfigured = !!action.payload.oauthConfigured;
        state.loading = false;
      })
      .addCase(getKlaviyoAccount.rejected, (state) => {
        // Fail safe: with the connection state unknown, behave as a Releva-transport
        // domain (show verification/disabled warnings) rather than hiding them.
        state.account = null;
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setKlaviyoAccount } = klaviyoSlice.actions;

export default klaviyoSlice.reducer;
